export default __webpack_public_path__ + "static/media/909-bright-crash.2ebb9e60.mp3";